// Extracted from enInbox.ts (file-length cap): the custom-column type labels plus the
// add-column modal tab / sticky add-control strings (PREC-3703). Spread back into the
// `inbox` namespace in enInbox.ts.
export const enInboxColumns = {
	TEXT: "Text",
	NUMBER: "Number",
	LINK: "Link",
	BOOLEAN: "Checkbox",
	AI_PROMPT: "AI Prompt",
	RANDOM_VALUE: "Random Value",
	GOOGLE_NEWS: "Google News",
	DEPARTMENT_SIZE: "Department Size",
	LINKEDIN_POST: "LinkedIn Post",
	JOB_OFFER: "Job Offer",
	JOB_CHANGE: "Employer Change",
	TECHNOLOGY: "Technology",
	DEEP_RESEARCH: "Deep Research",
	// Add-column modal tabs (PREC-3703).
	columnsTab: "Columns",
	enrichmentsTab: "Enrichments",
	usesCredits: "Uses credits",
	creditPerRow: "1 credit / row",
	// Sticky add-column / add-lead controls on the lead-list table (PREC-3703).
	addColumnCta: "Add a column",
	addLeadCta: "Add lead",
	// "Company was on other lists" column on the lead-list table (PREC-2750).
	companyOtherLists: "Company on other lists",
	companyOtherListsNone: "On no other list",
	companyOtherListsUnknown: "Company not identified — no match possible",
	companyOtherListsHeader_one: "Company is on {{count}} other list:",
	companyOtherListsHeader_other: "Company is on {{count}} other lists:",
	companyOtherListsLeads_one: "{{count}} lead",
	companyOtherListsLeads_other: "{{count}} leads",
	// "Company is on other list" filter in the lead-list filter modal (PREC-4447).
	companyOtherList: "Company is on other list",
};
